import type { CartData } from "@brytdesigns/shopify-ajax-cart";
import {
  makeFullPropertyPathContext,
  type Path,
  type PathValue,
} from "@brytdesigns/web-component-core";
import type { ICustomElement } from "component-register";
import { useAjaxCart } from "./useAjaxCart.js";

const hooks = makeFullPropertyPathContext<CartData>();

export type CartPath = Path<CartData>;
export type CartPathValue<Path extends CartPath> = PathValue<CartData, Path>;
export const useCartValue = (
  options: Omit<Parameters<typeof hooks.usePathValue>[0], "data"> & {
    element: HTMLElement & ICustomElement;
  },
) => {
  const data = useAjaxCart(options.element);
  return hooks.usePathValue({
    ...options,
    data,
  });
};
export const useCartPath = hooks.usePath;
export const useCartFormattedValue = (
  options: Omit<Parameters<typeof hooks.useFormattedValue>[0], "data"> & {
    element: HTMLElement & ICustomElement;
  },
) => {
  const data = useAjaxCart(options.element);
  return hooks.useFormattedValue({
    data,
    get format() {
      return options.format;
    },
    path: options.path,
  });
};
export const provideCartPathContext = hooks.provide;

export * from "./useAjaxCart.js";
export * from "./useListenerStatus.js";
